
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class ReporteEmbarqueSector3Linea7Service {
  static async getDataReporteEmbarqueSector3Linea7 (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector3_linea7?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 3.')
      return (data)
    })
  }

  static async getDataReporteEmbarqueSector3Linea7Total (cereal, cerealVariedad, etiqueta) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_vejez_sector3_linea7_total?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}","etiqueta":"${etiqueta}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de embarque sector 3.')
      return (data)
    })
  }
}
